import { Injectable } from '@angular/core';
import { UserServiceWebProvider } from '@web-services/user/user.service';

@Injectable()
export class ProductPackageService {
	constructor(private userService: UserServiceWebProvider) {}

	getCurrensySymbol(): string {
		let currensySymbol = this.userService.userCurrencySymbol;

		if (currensySymbol === 'د.إ') {
			currensySymbol = '';
		}

		return currensySymbol;
	}

	getTaxLabel(taxType: string): string {
		let taxLabel = '';
		switch (taxType) {
			case 'INCLUDED':
				taxLabel = 'Includes';
				break;
			case 'EXCLUDED':
				taxLabel = 'Excludes';
				break;
			case 'NO_TAX':
				taxLabel = 'No';
				break;
			default:
				return '';
		}
		return taxLabel;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/services/settings/productPackage.service.ts